const checkPermiUrl = [
];

export default checkPermiUrl;
